import React from 'react';
import Modal from "../../components/modal/modal";
import {toast, ToastTypes} from "../../components/toasts/toast/toast";
import axiosInstance from "../../AxiosInstance";
import { closeConfirmDeleteInvoice, openNecDetail } from "../bus/modalApi";
import { afterInvoiceActionSuccess } from "../bus/afterInvoiceActionSuccess";
import { purchaseOrderListHandlersRef } from "../bus/purchaseOrderListHandlersRef";
import { purchaseOrderInvoiceAmountLeft } from "../../utils/currency";

const COPY_DEFAULT = {
    title: 'Eliminar Documento',
    buttonName: 'Eliminar',
    body: (sn) => `¿Seguro que deseas eliminar el documento ${sn}?`,
    errorToast: 'No es posible eliminar esta factura.',
};

const COPY_DISASSOCIATE = {
    title: 'Desasociar comprobante',
    buttonName: 'Desasociar',
    body: (sn) =>
        `¿Seguro que deseas desasociar el comprobante ${sn} de esta NEC? El comprobante dejará de estar ligado a la orden según las reglas del sistema.`,
    errorToast: 'No es posible desasociar este comprobante.',
};

function rejectFailedResponse(response) {
    const status = response?.status ?? response?.response?.status;
    if (status >= 400) {
        return Promise.reject(response?.response ? response : { response });
    }
    return response;
}

function actionErrorMessage(err, fallback) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string' && detail.trim()) {
        return detail;
    }
    if (typeof err?.message === 'string' && err.message.trim()) {
        return err.message;
    }
    return fallback;
}

export default function ConfirmDeleteInvoiceModal({show, setter, invoice, intent, returnTo}) {
    const copy = intent === 'disassociate' ? COPY_DISASSOCIATE : COPY_DEFAULT;

    const confirmAction = async () => {
        try {
            const response = await (
                intent === 'disassociate'
                    ? axiosInstance.post(`bill/${invoice.id}/disassociate/`)
                    : axiosInstance.delete(`bill/${invoice.id}/`)
            ).then(rejectFailedResponse);

            const expectedStatus = intent === 'disassociate' ? 200 : 204;
            if (response.status !== expectedStatus) {
                toast(copy.errorToast, ToastTypes.ERROR);
                return;
            }

            if (
                intent === 'disassociate' &&
                (response.data?.purchase_order != null || response.data?.order_detail != null)
            ) {
                throw new Error('El servidor no confirmó la desasociación del comprobante.');
            }

            if (intent !== 'disassociate' || !returnTo?.ocId || !returnTo?.necId) {
                afterInvoiceActionSuccess(setter);
                return;
            }

            const ocResponse = await axiosInstance
                .get(`purchase_order/${returnTo.ocId}/`)
                .then(rejectFailedResponse);
            const nextOc = {
                ...ocResponse.data,
                amount_left: purchaseOrderInvoiceAmountLeft(ocResponse.data),
            };
            const nextNec = nextOc?.order_details?.find((nec) => String(nec.id) === String(returnTo.necId));
            if (!nextOc || !nextNec) {
                closeConfirmDeleteInvoice();
                return;
            }

            purchaseOrderListHandlersRef.current?.replacePurchaseOrder?.(nextOc);
            closeConfirmDeleteInvoice();
            openNecDetail({
                oc: nextOc,
                nec: nextNec,
                bill: null,
                userType: returnTo.userType,
            });
        } catch (err) {
            console.error(err);
            toast(actionErrorMessage(err, copy.errorToast), ToastTypes.ERROR);
        }
    };

    return (
        <Modal
            show={show}
            setter={setter}
            onClick={() => confirmAction()}
            name={copy.title}
            buttonName={copy.buttonName}
        >
            <div className={'mb-3'}>{copy.body(invoice?.sn ?? '')}</div>
        </Modal>
    );
}
